import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Users, Settings, Palette, Wand2 } from 'lucide-react';
import { SiteSettings } from '../components/admin/SiteSettings';
import { UserManagement } from '../components/admin/UserManagement';
import { Overview } from '../components/admin/Overview';
import { AISettings } from '../components/admin/AISettings';

export function Admin() {
  const navigate = useNavigate();
  const { isAdmin, loading } = useAuth();
  const [activeTab, setActiveTab] = useState<'overview' | 'users' | 'site' | 'ai'>('overview');

  if (loading || !isAdmin) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 bg-background">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground">Admin Dashboard</h1>
        <div className="flex flex-wrap gap-2 w-full sm:w-auto">
          <button
            onClick={() => setActiveTab('overview')}
            className={`flex-1 sm:flex-none px-3 sm:px-4 py-2 text-sm rounded-md ${
              activeTab === 'overview'
                ? 'bg-primary/10 text-primary'
                : 'text-muted-foreground hover:bg-secondary'
            }`}
          >
            Overview
          </button>
          <button
            onClick={() => setActiveTab('users')}
            className={`flex-1 sm:flex-none px-3 sm:px-4 py-2 text-sm rounded-md ${
              activeTab === 'users'
                ? 'bg-primary/10 text-primary'
                : 'text-muted-foreground hover:bg-secondary'
            }`}
          >
            Users
          </button>
          <button
            onClick={() => setActiveTab('site')}
            className={`flex-1 sm:flex-none px-3 sm:px-4 py-2 text-sm rounded-md ${
              activeTab === 'site'
                ? 'bg-primary/10 text-primary'
                : 'text-muted-foreground hover:bg-secondary'
            }`}
          >
            Site Settings
          </button>
          <button
            onClick={() => setActiveTab('ai')}
            className={`flex-1 sm:flex-none px-3 sm:px-4 py-2 text-sm rounded-md ${
              activeTab === 'ai'
                ? 'bg-primary/10 text-primary'
                : 'text-muted-foreground hover:bg-secondary'
            }`}
          >
            AI Settings
          </button>
        </div>
      </div>

      {activeTab === 'overview' && <Overview />}
      {activeTab === 'users' && <UserManagement />}
      {activeTab === 'site' && <SiteSettings />}
      {activeTab === 'ai' && <AISettings />}
    </div>
  );
}